import { render } from "./FlipCoinRules.vue?vue&type=template&id=0f11c06d"
import script from "./FlipCoinRules.vue?vue&type=script&lang=js"
export * from "./FlipCoinRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__